import React from 'react';
import UseLang from '../../../../components/hook/UseLang';

const HeaderDates = props => {

    const { date, item, day } = props

    if (item === 'header-date') {
        return (<>
            {day === '01/10/2023' && <>
                <UseLang es>Domingo {date}</UseLang>
                <UseLang en>Sunday {date}</UseLang>
                <UseLang pt_br>Domingo {date}</UseLang>
            </>}
            {day === '02/10/2023' && <>
                <UseLang es>Lunes {date}</UseLang>
                <UseLang en>Monday {date}</UseLang>
                <UseLang pt_br>Segunda {date}</UseLang>
            </>}
            {day === '03/10/2023' &&
                <>
                    <UseLang es>Martes {date}</UseLang>
                    <UseLang en>Tuesday {date}</UseLang>
                    <UseLang pt_br>Terça {date}</UseLang>
                </>
            }
            {day === '04/10/2023' && <>
                <UseLang es>Miércoles {date}</UseLang>
                <UseLang en>Wednesday {date}</UseLang>
                <UseLang pt_br>Quarta {date}</UseLang>
            </>}
            {day === '05/10/2023' &&
                <>
                    <UseLang es>Jueves {date}</UseLang>
                    <UseLang en>Thursday {date}</UseLang>
                    <UseLang pt_br>Quinta {date}</UseLang>
                </>
            }
            {day === '06/10/2023' && <>
                <UseLang es>Viernes {date}</UseLang>
                <UseLang en>Friday {date}</UseLang>
                <UseLang pt_br>Sexta {date}</UseLang>
            </>}
        </>)
    }
}

export default HeaderDates;
